const ensureTrailingSlash = (url: string) => {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
};

export const environment = {
  ADMIN_PORTAL: ensureTrailingSlash(import.meta.env.VITE_ADMIN_PORTAL ?? ""),
  STUDENT_PORTAL: ensureTrailingSlash(import.meta.env.VITE_STUDENT_PORTAL ?? ""),
  TAKE_EXAM: ensureTrailingSlash(import.meta.env.VITE_TAKE_EXAM ?? ""),
  QUESTION_CONTRIBUTOR: ensureTrailingSlash(import.meta.env.VITE_QUESTION_CONTRIBUTOR ?? ""),
  POWERED_BY: import.meta.env.VITE_POWERED_BY ?? "",
  LANDING_PAGE: ensureTrailingSlash(import.meta.env.VITE_LANDING_PAGE ?? ""),
};
